import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../RegistrationPopup/redux/registrationPopupActions';
import {changePhone} from 'src/components/User/redux/userAction.js';
import styles from 'src/styles/AuthPopup.scss';
import PopoverTrigger from 'src/components/popover/PopoverTrigger';
import EditPhoneInput from './EditPhoneInputTimer';
import cx from 'classnames';
import {canResetPasswordResendTimestamp} from 'src/logic/utils';
import {findDOMNode} from 'react-dom';
import fm from 'src/logic/formatMessage';
import { hashPassword } from 'src/logic/authHelpers';

class EditPhoneInputSecondStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
  }

  submitPassword = (e) => {
    this.props.requestChangePhone(hashPassword(this.refs.passwordInput.value))
    .then((res) => {
      if(res.error) {
        alert(res.error); //TODO: handle error code here
      }
      else{
        console.log('newPhone', this.props.newPhone);
        this.props.changePhone(this.props.newPhone);
      }
    });
  };

  render() {
    const {sentPasswordErr, returnToFirstStep} = this.props;
    const passwordInputContainerClassName = {
      [styles.input]: true,
      'input-text': true,
      [styles.invalidInput]: !!sentPasswordErr
    };
    return (
        <div className={styles.phoneInputContainer}>
          <PopoverTrigger
            content={fm(this.props.sentPasswordErr)}
            placement="left">
            <input
              ref="passwordInput"
              required
              type="password"
              placeholder="Введите код из SMS"
              className="form-control col-5 m-r-1" />
          </PopoverTrigger>
          <EditPhoneInput />
          <button onClick={this.submitPassword}  className="btn btn-secondary p-x-1 p-y-0_3">Подтвердить</button>
        </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.registrationPopupReducer,
    newPhone: state.userReducer.NewPhone
  }),
  (dispatch) => ({
    ...bindActionCreators(actions, dispatch),
    changePhone: bindActionCreators(changePhone, dispatch)
  })
)(EditPhoneInputSecondStep);



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/EditPhoneInputSecondStep.jsx
 **/